import { render, staticRenderFns } from "./PsrHeaderPatientDoctor.vue?vue&type=template&id=4ed1225a&scoped=true&"
import script from "./PsrHeaderPatientDoctor.vue?vue&type=script&lang=js&"
export * from "./PsrHeaderPatientDoctor.vue?vue&type=script&lang=js&"
import style0 from "./PsrHeaderPatientDoctor.vue?vue&type=style&index=0&id=4ed1225a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed1225a",
  null
  
)

export default component.exports